import React from 'react';
import { Button } from 'tea-component';
import { useIntl, getLocale } from 'umi';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import { useGenreNameIntlHooks } from '@intelligence/pages/MarketProfile/hooks/useGenreNameIntlHooks';
// import { useGenreNameIntlHooks } from '@intelligence/pages/MarketProfile/hooks/useGenreNameIntlHooks';

export default function SpecialColContent(props) {
  const { context, config, hideCond, getIsHideCol, onGameItemClick, isLabelHide } = props;

  const { type, key, clickKey, align = 'right', childWidth, childAlign } = config || {};

  const { formatMessage } = useIntl();
  const locale = getLocale();

  // const { genres, getSubGenresList, getMainGenresMap, getSubGenresMap } = useGenreNameIntlHooks({
  //   isIegg: true,
  //   entityType: 'mobile',
  // });

  const isHide =
    hideCond &&
    getIsHideCol instanceof Function &&
    getIsHideCol(hideCond, context, 'specicalContent');

  // console.debug('specialColContent', {
  //   type,
  //   key,
  //   clickKey,
  //   config,
  //   locale,
  //   // getSubGenresMap,
  //   // getMainGenresMap,
  //   // genreOptions,
  //   // mainGenres,
  //   // subGenres,
  //   // filterLoading,
  //   // genres,
  //   // options,
  // });

  const genreKeys = ['genre', 'sub_genre'];
  const needMappingNameCondi = genreKeys.includes(key);
  const isSub = needMappingNameCondi && key?.includes('sub_');

  // const linkLabel = !needMappingNameCondi ? formatMessage({ id: key }) : isSub ? getSubGenresMap() : ;

  // 这里逻辑有问题，不应该拿key去做国际化的，目前判断key是否携带$只是临时方案
  // const linkLabel = !needMappingNameCondi ? (key?.includes('$') && formatMessage({ id: key })) : isSub ? '-' : '-';

  const isActionBtn = type === 'action';

  const actionLabel = isActionBtn ? formatMessage({ id: key }) : '-';

  const linkLabel = !needMappingNameCondi ? (isActionBtn ? actionLabel : isSub ? '-' : '-') : '-';

  const getElContent = (_type: string) => {
    // if (!!isHide) return null;
    if (!!isHide) return '-';
    switch (_type) {
      // 文本来源于接口，所以中英翻译要借助字段转换
      case 'text':
        const name = context[key];
        const nameCn = context[`${key}_cn`] || name;

        return (
          <span
            style={{
              display: isLabelHide ? 'none' : '',
            }}
          >
            {locale === 'zh-CN' ? nameCn : name}
          </span>
        );
      case 'action':
        return (
          <Button
            className="table-link"
            style={{
              display: isLabelHide ? 'none' : '',
            }}
            onClick={() => {
              if (onGameItemClick instanceof Function) {
                onGameItemClick(clickKey, context);
              }
            }}
            type="link"
          >
            {linkLabel ? linkLabel : '-'}
          </Button>
        );
      default:
        return null;
    }
  };
  return (
    <>
      {align === 'center' ? (
        <CloumsCenter width={childWidth} align={childAlign}>
          {getElContent(type)}
        </CloumsCenter>
      ) : (
        getElContent(type)
      )}
    </>
  );
}
